module.exports = __webpack_public_path__ + "static/media/pic5.ca61c00d.jpg";